import React from 'react';

import Aux from './../../../hoc/_Aux';

import Zigzag from './../../UI/Common/Shapes/Zigzag';
import DoubleZigzag from './../../UI/Common/Shapes/DoubleZigzag';
import DoubleHalfCircle from './../../UI/Common/Shapes/DoubleHalfCircle';
import Triangle from './../../UI/Common/Shapes/Triangle';

/**
 * Container used, in article's details page, to display the dedicated "job block"  
 */
const JobBlock = (props) => {

    let blocOutput = null;
    let jobEntries = null;

    if(typeof props.content !=='undefined'){
        jobEntries = props.content.map((entry, index) => {

            let description = entry.description;
            const descrptionClean = description.replace(/\\'/g, '\'');

            return (
                <li key={index}>{entry.title} :<span>{descrptionClean}</span></li>
            );
        });
    }

    blocOutput = (
                    <div className={props.classes.join(' ')}>  
                        <div className="title">Fiche Métier</div>
                        <ul>
                           {jobEntries}
                        </ul>

                        <div className="purple-zigzag">    
                            <Zigzag color="#241459" />
                        </div>
                        <div className="pink-triangle">
                            <Triangle color="#ff8377" rotateAngle="-50" />
                        </div>
                        <div className="dual-zigzag">
                            <DoubleZigzag color1='#30e6ca' color2='#ff8377' rotateAngle="-35"/>
                        </div>
                        <div className="dual-half-circle">
                            <DoubleHalfCircle color1='#eee' color2='#fcea10' rotateAngle="-95"/>
                        </div>   

                    </div>
                );


    return(
        <Aux>
            {blocOutput}
        </Aux> 

    )
}

export default JobBlock;



// WEBPACK FOOTER //
// ./src/containers/Article/Details/JobBlock.js